import React, { Component } from "react";
import styles from "./style.module.scss";
import { Button, Form, Input, Menu, Modal, Select, Typography } from "antd";
import { observer } from "mobx-react";
import { observable } from "mobx";
import industries from "./industry.json";
import countries from "./countryCode.json";
import { QUERY, MUTATE } from "../../utilities/network";
import { RouteComponentProps } from "react-router";
import { FormComponentProps } from "antd/es/form";
import UserInfo from "../../store/userInfo";
import { Button as MuiButton } from "@material-ui/core";
import styled from "styled-components";

const CustomMenu = styled(Menu)`
.navLink:hover {
color: #6001d9;
}
&& .ant-menu-item-selected {
background-color: #6001d9;
color: #fff;
}}`;

const countryNames: Array<string> = countries.map((e) => e.label);
const organizationSizes = [
  "1-24 employees",
  "25-150 employees",
  "151-500 employees",
  "500-2000 employees",
  "2000+ employees",
];

@observer
class Settings extends Component<FormComponentProps & RouteComponentProps<{}>> {
  @observable selectedMenu: "Account settings" | "Organization settings" = "Account settings";
  @observable settingsData: SettingsDataType | undefined;
  @observable loading = false;

  async componentDidMount() {
    await this._getSettings();
  }

  render() {
    return (
      <div className={styles.container}>
        <CustomMenu
          className={styles.menu_bar}
          onClick={this._onClickMenuBar}
          defaultSelectedKeys={[this.selectedMenu]}
          mode="inline"
        >
          <Menu.Item className="navLink" key="Account settings">
            Account settings
          </Menu.Item>
          <Menu.Item className="navLink" key="Organization settings">
            Organization settings
          </Menu.Item>
        </CustomMenu>

        {this._renderContent()}
      </div>
    );
  }

  _renderContent = () => {
    if (this.selectedMenu === "Account settings") {
      return this._renderAccountSettings();
    } else if (this.selectedMenu === "Organization settings") {
      return this._renderOrganizationSettings();
    }
  };

  _renderAccountSettings = () => {
    const rules = [
      {
        key: "name",
        options: {
          initialValue: this.settingsData && this.settingsData.name,
          rules: [
            {
              required: true,
              message: `Please input administrators name.`,
            },
            {
              max: 50,
              message: "Name must be shorter than 50 digits.",
            },
          ],
        },
      },
      {
        key: "email",
        options: {
          initialValue: this.settingsData && this.settingsData.email,
          rules: [
            {
              required: true,
              message: `Please input administrator's Email.`,
            },
          ],
        },
      },
      {
        key: "pwd",
        options: {
          rules: [
            {
              min: 6,
              message: "Password must be longer than 6 digits.",
            },
          ],
        },
      },
    ];

    return (
      <div className={styles.content_box}>
        <Typography.Title level={4}>Account settings</Typography.Title>
        <Form layout="vertical" className={styles.form}>
          <Form.Item label="Administrator's name">
            {this.props.form.getFieldDecorator(
              rules[0].key,
              rules[0].options,
            )(<Input placeholder="Administrator's name" />)}
          </Form.Item>
          <Form.Item label="Administrator's Email">
            {this.props.form.getFieldDecorator(
              rules[1].key,
              rules[1].options,
            )(<Input placeholder="Administrator's Email" />)}
          </Form.Item>
          <Form.Item label="Administrator's password">
            {this.props.form.getFieldDecorator(
              rules[2].key,
              rules[2].options,
            )(<Input.Password placeholder="Administrator's password" />)}
          </Form.Item>
          <Form.Item>
            <MuiButton
              color="primary"
              variant="contained"
              disabled={this.loading}
              onClick={this._onUpdateAccountInfo}
            >
              Update information
            </MuiButton>
          </Form.Item>
        </Form>
      </div>
    );
  };

  _renderOrganizationSettings = () => {
    let name,
      industry,
      size,
      headquarters = undefined;
    if (this.settingsData && this.settingsData.organization) {
      name = this.settingsData.organization.name;
      industry = this.settingsData.organization.industry;
      size = this.settingsData.organization.size;
      headquarters = this.settingsData.organization.headquarters;
    }
    const rules = [
      {
        key: "company_name",
        options: {
          initialValue: name,
          rules: [
            {
              required: true,
              message: "Please input the name of organization.",
            },
            {
              max: 64,
              message: "Maximum length 64.",
            },
          ],
        },
      },
      {
        key: "company_industry",
        options: {
          initialValue: industry,
          rules: [
            {
              required: true,
              message: "Please choose industry sector.",
            },
          ],
        },
      },
      {
        key: "company_size",
        options: {
          initialValue: size,
          rules: [
            {
              required: true,
              message: "Please choose the size of organization.",
            },
          ],
        },
      },
      {
        key: "company_headquarters",
        options: {
          initialValue: headquarters,
          rules: [
            {
              required: true,
              message: "Where is the headquarters?",
            },
          ],
        },
      },
    ];

    return (
      <div className={styles.content_box}>
        <Typography.Title level={4}>Organization settings</Typography.Title>
        <Form layout="vertical" className={styles.form}>
          <Form.Item label="Organization's name">
            {this.props.form.getFieldDecorator(
              rules[0].key,
              rules[0].options,
            )(<Input placeholder="Enter the name of organization" />)}
          </Form.Item>
          <Form.Item label="Industry sector">
            {this.props.form.getFieldDecorator(
              rules[1].key,
              rules[1].options,
            )(
              <Select placeholder="Choose industry sector">
                {industries.map((industry) => (
                  <Select.Option value={industry} key={industry}>
                    {industry}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label="Size of organization">
            {this.props.form.getFieldDecorator(
              rules[2].key,
              rules[2].options,
            )(
              <Select placeholder="Choose the size of organization">
                {organizationSizes.map((size) => (
                  <Select.Option value={size} key={size}>
                    {size}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label="Headquarters">
            {this.props.form.getFieldDecorator(
              rules[3].key,
              rules[3].options,
            )(
              <Select placeholder="Where is the headquarters?">
                {countryNames.map((country) => (
                  <Select.Option value={country} key={country}>
                    {country}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item>
            <MuiButton
              color="primary"
              variant="contained"
              onClick={this._onUpdateOrganizationInfo}
              disabled={this.loading}
            >
              Update information
            </MuiButton>
          </Form.Item>
        </Form>
      </div>
    );
  };

  _onClickMenuBar = (e: { key: any }) => {
    if (this.selectedMenu !== e.key) {
      this.selectedMenu = e.key;
    }
  };

  _getSettings = async () => {
    try {
      this.settingsData = (await QUERY<{ account: SettingsDataType }>(GET_SETTINGS)).account;
    } catch (e) {
      Modal.error({
        title: "Oops, something goes wrong.",
        content: e.message,
        okText: "GOT IT",
      });
    }
  };

  _onUpdateAccountInfo = () => {
    this.props.form.validateFields(async (error, values) => {
      if (!error) {
        try {
          this.loading = true;

          await MUTATE(UPDATE_ACCOUNT_INFO, values);
          UserInfo.updateAccount(values.email);

          Modal.success({
            title: "Update successfully.",
            onOk: this._getSettings,
          });
        } catch (e) {
          Modal.error({
            title: "Oops, something goes wrong.",
            content: e.message,
            okText: "GOT IT",
          });
        } finally {
          this.loading = false;
        }
      }
    });
  };

  _onUpdateOrganizationInfo = () => {
    this.props.form.validateFields(async (error, values) => {
      if (!error) {
        try {
          this.loading = true;

          await MUTATE(UPDATE_COMPANY_INFO, values);
          Modal.success({
            title: "Update successfully.",
            onOk: this._getSettings,
          });
        } catch (e) {
          Modal.error({
            title: "Oops, something goes wrong.",
            content: e.message,
            okText: "GOT IT",
          });
        } finally {
          this.loading = false;
        }
      }
    });
  };
}

export default Form.create()(Settings);

const GET_SETTINGS = `
query {
  account: administratorInfo {
    name
    email
    type
    organization {
      name
      industry
      size
      headquarters
    }
  }
}`;

export enum AdministratorType {
  God = "God",
  Super = "Super",
  Basic = "Basic",
}

interface SettingsDataType {
  name: string;
  email: string;
  type: AdministratorType;

  organization?: {
    name: string;
    industry: string;
    size: string;
    headquarters: string;
  };
}

const UPDATE_ACCOUNT_INFO = `
mutation($pwd: String, $email: EmailAddress!, $name: String!) {
  updateAdministratorInfo(pwd: $pwd, email: $email, name: $name) {
    name
    email
  }
}`;

const UPDATE_COMPANY_INFO = `
mutation(
  $company_name: String!
  $company_industry: String!
  $company_size: String!
  $company_headquarters: String!
) {
  updateOrganizationInfo(
    headquarters: $company_headquarters
    size: $company_size
    industry: $company_industry
    name: $company_name
  ) {
    name
    industry
    size
    headquarters
  }
}`;
